import { useEffect, useState } from "react";
// import Locked_icon from "icons/Locked_icon.svg";
// import { ConditionalRenderer } from "../../components";
// import { CustomTooltip } from "components/tooltip";
// import { getTooltipData } from "pages/clubFitting/helpers";
import styles from "./styles.module.scss";

function BaseballTile({
  title,
  value,
  unit,
  variant,
  hideBorder,
  isLocked,
  isWholeNumber,
  isLandscape,
  onCompare,
  isClubFittingScreen,
  styleVariant,
  clubFittingFirstColumn,
}) {
  const [tooltipId, setTooltipId] = useState("");

  useEffect(() => {
    function generateRandomId() {
      const randomString = Math.random().toString(36).slice(2, 8);
      const randomNumber = Math.floor(Math.random() * 1000);

      return `${randomString}-${randomNumber}`;
    }

    setTooltipId(generateRandomId());
  }, []);

  const innerContainerClassName = `${
    isClubFittingScreen ? styles.clubFittingTile : styles.tile
  } ${styles[`tile${variant}`]} ${isLocked ? styles.bgLock : ""}`;

  const titleClassName = `${styles.tileName}
   ${styles[`tileBackground${variant}`]}`;

  function getTileContainerClass() {
    if (isLandscape && !onCompare) {
      return "landscapeTileContainer";
    } else if (isClubFittingScreen) {
      return clubFittingFirstColumn
        ? "clubFittingFirstColTileContainer"
        : "clubFittingTileContainer";
    }
    return "tileContainer";
  }
  function getHeaderClass() {
    return isClubFittingScreen ? styles.clubFittingHeader : "";
  }

  function toolTipHandler() {
    const tooltipel = document.getElementById(tooltipId);
    if (tooltipel) {
      tooltipel.classList.remove(styles.hideTooltip);
      tooltipel.classList.add(styles.showTooltip);
    }
  }

  function toolTipHideHandler() {
    const tooltipel = document.getElementById(tooltipId);
    if (tooltipel) {
      tooltipel.classList.remove(styles.showTooltip);
      tooltipel.classList.add(styles.hideTooltip);
    }
  }

  const styleVariantObj = {
    "force-tile": "tileForForces",
    "tile-for-update-popup": "tileForModal",
    "inactive-tile-for-update-popup": "inactiveTileForModal",
    "launch-monitor": "launchMonitorTiles",
  };

  const componentClass = styles[styleVariantObj[styleVariant]];

  return (
    <div
      className={[
        `${styles[getTileContainerClass()]} ${
          styles[variant]
        } ${componentClass}`,
      ]}
      id={`${tooltipId}-container`}
    >
      <ShowBorder hideBorder={hideBorder} variant={variant} />
      <div className={innerContainerClassName} style={{ height: "100%" }}>
        <div className={getHeaderClass()}>
          <h1 className={titleClassName}>{title}</h1>
          {/* <h1 className={styles.tileName}>{title}</h1> */}
          {/* <ConditionalRenderer
            condition={isClubFittingScreen && getTooltipData({ title, unit })}
          >
            <div
              className={styles.tooltip}
              onMouseEnter={toolTipHandler}
              onMouseLeave={toolTipHideHandler}
            >
              i
            </div>
            <CustomTooltip
              title={getTooltipData({ title, unit })}
              variant={variant}
              tooltipId={tooltipId}
              value={value}
            />
          </ConditionalRenderer> */}
        </div>
        <ShowValue
          isLocked={isLocked}
          value={value}
          isWholeNumber={isWholeNumber}
        />
        <ShowUnit unit={unit} />
      </div>
    </div>
  );
}

function ShowBorder({ hideBorder, variant }) {
  if (hideBorder) {
    return <></>;
  }
  return (
    <div
      className={`${styles.borderLine} ${styles[`line${variant}`]}`}
      style={{ height: "90%" }}
    />
  );
}

function ShowValue({ isLocked, value, isWholeNumber }) {
  const fixedValue = (valueLocal) => {
    const digitsAfterDecimal = isWholeNumber ? 0 : 1;
    const finalValue = valueLocal
      ? Number(value).toFixed(digitsAfterDecimal)
      : 0;
    if (finalValue === "NaN") {
      return value;
    }
    return finalValue;
  };

  // if (isLocked) {
  //   return (
  //     <div className={styles.lockedCircle}>
  //       <img src={Locked_icon} alt="Locked_icon" />
  //     </div>
  //   );
  // }
  return <h1 className={styles.tileValue}>{fixedValue(value)}</h1>;
}

function ShowUnit({ unit }) {
  // if (!unit) {
  //   return <></>;
  // }
  return (
    <h1 className={styles.tileUnit} style={{ visibility: !unit && "hidden" }}>
      {unit ? unit : "null"}
    </h1>
  );
}

export { BaseballTile };
